
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, List, ListItem, Typography } from "@mui/material"

import moment from "moment"

import { formatCurrency } from "../helpers/FormatCurrency"
import { InfoField } from "../components/InfoField"

import { DialogContentStyle, DialogActionsStyle } from "../styles/DialogStyle"

import { ExhortoRecibidoProps } from "../interfaces/recepcion/ExhortoRecibidoInterface"

interface Props {
    exhortoRecibido?:   ExhortoRecibidoProps;
    openDialog:         boolean;
    handleCloseDialog:  () => void;
}

export const DialogExhortoRecibido = ({ exhortoRecibido, openDialog, handleCloseDialog }: Props) => {

    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={ openDialog }
            onClose={ () => {} }
        >

            <DialogTitle>
                Información del exhorto recibido
            </DialogTitle>

            <DialogContent sx={{ ...DialogContentStyle, pt: 3 }}>

                <Grid container spacing={3}>

                    {
                        exhortoRecibido?.folioBuzonElectronico
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Folio buzón electrónico"
                                    value={ exhortoRecibido?.folioBuzonElectronico }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        exhortoRecibido?.numeroFolio
                        ?
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Número de exhorto"
                                    value={
                                        <>
                                            { exhortoRecibido?.numeroExhorto }
                                            { exhortoRecibido?.numeroFolio && <small style={{ fontSize: 14 }}> (F. { exhortoRecibido?.numeroFolio })</small> }
                                        </>
                                    }
                                    fontSize={ 16 }
                                />
                            </Grid>
                        :
                            exhortoRecibido?.numeroExhorto
                            &&
                                <Grid size={{ md: 6, xs: 12 }}>
                                    <InfoField
                                        label="Número de exhorto"
                                        value={ exhortoRecibido?.numeroExhorto }
                                        fontSize={ 16 }
                                    />
                                </Grid>
                    }

                    {
                        exhortoRecibido?.numeroExpedienteOrigen
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Número de expediente de origen"
                                    value={ exhortoRecibido?.numeroExpedienteOrigen }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        exhortoRecibido?.fecha
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Fecha"
                                    value={ moment( new Date( exhortoRecibido?.fecha ) ).format( 'DD-MM-YYYY' ) }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        exhortoRecibido?.tipoJuicio
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Tipo de juicio"
                                    value={ exhortoRecibido?.tipoJuicio }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        exhortoRecibido?.cuantia
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Cuantía"
                                    value={ formatCurrency( exhortoRecibido?.cuantia ) }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        exhortoRecibido?.autoridadExhortoRecibido
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Autoridad del exhorto recibido"
                                    value={ exhortoRecibido?.autoridadExhortoRecibido }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        exhortoRecibido?.claseExhorto
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Clase del exhorto"
                                    value={ exhortoRecibido?.claseExhorto }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        exhortoRecibido?.objetoExhorto
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Objeto del exhorto"
                                    value={ exhortoRecibido?.objetoExhorto }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        ( exhortoRecibido?.etapa && exhortoRecibido?.subEtapa )
                        ?
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Etapa"
                                    value={ `${ exhortoRecibido?.etapa } (${ exhortoRecibido?.subEtapa })` }
                                    fontSize={ 16 }
                                />
                            </Grid>
                        :
                            exhortoRecibido?.etapa
                            &&
                                <Grid size={{ md: 6, xs: 12 }}>
                                    <InfoField
                                        label="Etapa"
                                        value={ exhortoRecibido?.etapa }
                                        fontSize={ 16 }
                                    />
                                </Grid>
                    }

                    {
                        exhortoRecibido?.juez
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Juez"
                                    value={ exhortoRecibido?.juez }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        exhortoRecibido?.secretario
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Secretario(a) admisibilidad"
                                    value={ exhortoRecibido?.secretario }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        exhortoRecibido?.juzgadoOrigen
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>
                                <InfoField
                                    label="Juzgado de origen"
                                    value={ exhortoRecibido?.juzgadoOrigen }
                                    fontSize={ 16 }
                                />
                            </Grid>
                    }

                    {
                        ( exhortoRecibido?.actores && exhortoRecibido.actores.length !== 0 )
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>

                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: "text.secondary", letterSpacing: 0.5, fontWeight: 700 }}
                                >
                                    Actor(es):
                                </Typography>

                                <List disablePadding>
                                    {
                                        exhortoRecibido.actores.map( (actor, index) => (
                                            <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight='bold' fontSize={ 16 }>{ actor }</Typography>
                                            </ListItem>
                                        ))
                                    }
                                </List>

                            </Grid>
                    }

                    {
                        ( exhortoRecibido?.demandados && exhortoRecibido.demandados.length !== 0 )
                        &&
                            <Grid size={{ md: 6, xs: 12 }}>

                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: "text.secondary", letterSpacing: 0.5, fontWeight: 700 }}
                                >
                                    Demandado(s):
                                </Typography>

                                <List disablePadding>
                                    {
                                        exhortoRecibido.demandados.map( (demandado, index) => (
                                            <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight='bold' fontSize={ 16 }>{ demandado }</Typography>
                                            </ListItem>
                                        ))
                                    }
                                </List>

                            </Grid>
                    }

                    {
                        exhortoRecibido?.digitalizacion
                        &&
                            <Grid size={{ md: 12, xs: 12 }}>

                                <Typography
                                    variant="subtitle2"
                                    sx={{ color: "text.secondary", letterSpacing: 0.5, fontWeight: 700 }}
                                >
                                    Digitalización:
                                </Typography>

                                <iframe
                                    title='iframe-documento'
                                    style={{ width: '100%', height: 500, borderRadius: 8 }}
                                    src={ exhortoRecibido?.digitalizacion ?? '' }
                                />

                            </Grid>
                    }

                </Grid>

            </DialogContent>

            <DialogActions sx={{ ...DialogActionsStyle }}>
                <Button color="secondary" onClick={ handleCloseDialog }>Cerrar</Button>
            </DialogActions>

        </Dialog>
    )
}
